import { Box, Chip, Divider, ListItemButton, Typography } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import { FormSubmission } from '@uplift/types';
import React from 'react';
import { CalendarDateService } from '@uplift/services';
import { useTimezone } from '@uplift/contexts';


const StyledListItem = withStyles(ListItemButton, theme => ({
  root: {
    '&:after': {
      content: '""',
      position: 'absolute',
      width: '0px',
      height: '100%',
      top: '0px',
      left: '0px',
      backgroundColor: theme.palette.secondary.main,
      transitionDuration: '60ms',
    },

    '&.Mui-selected': {
      backgroundColor: theme.palette.common.white,
      cursor: 'default',

      '&:hover': {
        backgroundColor: theme.palette.common.white,
      }
    },
  },
  selected: {
    color: theme.palette.secondary.main,
    position: 'relative' as const,

    '&:after': {
      transitionDuration: '140ms',
      width: '4px',
    },
  },
  disabled: {
    backgroundColor: theme.palette.grey[100],
  }
}));


export const AssessmentSubmissionItem: React.FC<{
  selected: boolean;
  onSelect: () => void;
  score: number;
  submission: FormSubmission;
}> = ({ submission, score, onSelect, selected }) => {
  const timezone = useTimezone();
  const disabled = !!submission.expiredAt || !submission.complete;

  const content = React.useMemo(() => {
    if (submission.expiredAt) {
      return (
        <Chip
          size="small"
          variant="outlined"
          label={`Expired ${CalendarDateService.format(submission.expiredAt, 'MMM D', 'MMM DD, YYYY', { timezone })}`}
        />
      );
    }

    if (!submission.complete) {
      return <Chip size="small" variant="outlined" label="Incomplete" />;
    }

    return (
      <Box fontSize="24px" fontWeight="700" color="inherit">
        {score}
      </Box>
    );
  }, [ score, timezone, submission.expiredAt, submission.complete ]);

  return (
    <>
      <StyledListItem
        selected={selected}
        onClick={onSelect}
        disabled={disabled}
        dense
      >
        <Box display="flex" alignItems="center" width="300px" py={2}>
          {content}
          <Box flex="1" display="flex" justifyContent="flex-end">
            <Typography component={selected ? 'strong' : 'span'} variant="body2" color="inherit">
              {CalendarDateService.format(submission.createdAt, 'MMM D', 'MMM DD, YYYY', { timezone })}
            </Typography>
          </Box>
        </Box>
      </StyledListItem>
      <Divider />
    </>
  );
};
